import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import Source from './icon-lead-closed-goal.svg';

// @ts-expect-error
function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <Source {...validProps} />;
}
SvgComponent.iconName = 'goalLeadClosed';

/**
 * @deprecated This is a legacy icon
 */
export const GoalLeadClosedIcon = svgIconWrapper(SvgComponent);
